module.exports = __webpack_public_path__ + "static/media/10.4e6abd90.jpg";